// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import ClickGamesController from "./click_games_controller"
application.register("click-games", ClickGamesController)

import HelloController from "./hello_controller"
application.register("hello", HelloController)

import OrientationController from "./orientation_controller"
application.register("orientation", OrientationController)

import TiktokShareController from "./tiktok_share_controller"
application.register("tiktok-share", TiktokShareController)

import TooltipController from "./tooltip_controller"
application.register("tooltip", TooltipController)
